<template>
  <div>
    <v-alert
      border="left"
      class="ml-0 mr-0"
      type="info"
      text
      :color="secondaryColor"
      ><ParagraphBlock :html="text.content"></ParagraphBlock></v-alert
    >
  </div>
</template>

<script>

import { isWhite } from "../../util/color";
import ParagraphBlock from "./paragraphBlock.vue"

export default {
  name: "AlertBlock",
  props: ["text"],
  components: {ParagraphBlock},
  computed: {
    secondaryColor() {
      if (isWhite(this.$vuetify.theme.themes.light.secondary)) {
        return '#000000'
      } else {
        return this.$vuetify.theme.themes.light.secondary
      }
    }
  }
};
</script>

<style scoped>
</style>